// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".more[data-v-60ecac75]:before{border-radius:7.5px;content:\"\";display:inline-block;height:15px;margin-right:15px;width:15px;--tw-bg-opacity:1;background-color:#fef035;background-color:rgba(254,240,53,var(--tw-bg-opacity,1))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
